<template>
  <v-dialog
    v-model="dialogVisible"
    persistent
    width="750px"
  >
    <v-card>
      <v-toolbar class="mb-4">
        <v-toolbar-title data-testid="toolbar-title"><span class="text-h5">{{ $t('userPictureProfiles.title') }}</span></v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <div v-if="dataImages.length === 0" class="ml-6 mr-6 mt-6">
          <v-alert
            shaped
            text
            type="info"
          >{{ $t('userPictureProfiles.emptyPlaceholder') }}</v-alert>
        </div>
        <div v-else>
          <vue-select-image
            id="images_selection"
            data-testid="vue-select-image"
            ref="images"
            :dataImages="dataImages"
            class="pr-8 mt-5"
            @onselectimage="onSelectImage"
            :selectedImages="selectedImage"
            :rootClass="'custom-style'"
            :useLabel="metadata.length > 1"
            w="256" h="256">
          </vue-select-image>
        </div>
        <v-alert shaped text type="info" class="mt-4">
          {{ $t('userPictureProfiles.reloadRequired') }}
        </v-alert>
        <div class="d-flex flex-row ml-6 mr-6 mt-10">
          <v-file-input
            v-model="file"
            data-testid="file-input"
            accept="image/png, image/jpeg, image/gif"
            :placeholder="$t('userPictureProfiles.fileField.placeholder')"
            show-size
            counter
            small-chips
            prepend-icon="mdi-image"
            :label="$t('userPictureProfiles.fileField.label')"
            @change="cropImage"
          ></v-file-input>
          <v-btn
            class="ml-3 mt-5"
            fab
            small
            elevation="2"
            color="primary"
            data-testid="upload-btn"
            :loading="uploading"
            :disabled="file===null"
            @click="uploadProfilePicture()"
          ><v-icon>mdi-upload</v-icon></v-btn>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text data-testid="close-btn" @click="$emit('open-close-picture-profile-dialog')">
          {{ $t('userPictureProfiles.btn.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <CropperDialog :dialog="cropping" :file="rawFile" @stop-cropping="stopCropping" @cropped-image="setCroppedImage"/>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import VueSelectImage from 'vue-select-image'
import CropperDialog from '@/components/user_picture_profiles/cropper_dialog.vue'
export default {
  name: 'current-user-picture-profile',
  components: { VueSelectImage, CropperDialog },
  props: {
    dialog: { type: Boolean, default: false },
    user: { type: Object, default: null }
  },
  data () {
    return {
      file: null,
      uploading: false,
      cropping: false,
      rawFile: null
    }
  },
  created () {
    if (!this.loaded) {
      this.getMetadata()
    }
  },
  computed: {
    ...mapGetters({
      metadata: 'userPictureProfiles/metadata',
      loaded: 'userPictureProfiles/loaded'
    }),
    dataImages () {
      return this.metadata.map(pictureData => {
        return {
          id: pictureData.id,
          src: pictureData.url,
          alt: this.$t(`userPictureProfiles.pictureTypes.${pictureData.pictureType}`),
          pictureType: pictureData.pictureType,
          disabled: this.metadata.length === 1
        }
      })
    },
    selectedImage () {
      const selectedImg = this.metadata.find(pictureData => pictureData.isActive === true)
      return [{
        id: selectedImg?.id,
        src: selectedImg?.url,
        alt: selectedImg?.pictureType,
        pictureType: selectedImg?.pictureType,
        disabled: this.metadata?.length === 1
      }]
    },
    dialogVisible: {
      get () {
        return this.dialog
      },
      set (value) {
        if (!value) this.$emit('open-close-picture-profile-dialog')
      }
    }
  },
  methods: {
    ...mapActions({
      upload: 'userPictureProfiles/upload',
      switch: 'userPictureProfiles/switch',
      getMetadata: 'userPictureProfiles/getMetadata'
    }),

    onSelectImage (selectedImg) {
      this.switch(selectedImg.pictureType)
    },

    async uploadProfilePicture () {
      if (this.file) {
        this.uploading = true
        await this.upload(this.file)
        this.file = null
        this.uploading = false
        // if you ever find a better way for this, be my guest ;P
        const uploadTranslatedAlt = this.$t('userPictureProfiles.pictureTypes.uploaded')
        if (document) {
          document.querySelector('#images_selection').querySelector(`img[alt=${uploadTranslatedAlt}]`).click()
        }
      }
    },

    cropImage (rawFile) {
      if (rawFile) {
        this.cropping = true
        this.rawFile = rawFile
      } else {
        this.cropping = false
        this.rawFile = null
      }
    },

    stopCropping: function () {
      this.cropping = false
    },

    setCroppedImage: function (croppedImage) {
      this.file = croppedImage
    }
  }
}
</script>

<style lang="scss">
.custom-style {
  display: flex;
  justify-content: center;
  &__wrapper {
    overflow: auto;
    list-style-image: none;
    list-style-position: outside;
    list-style-type: none;
    padding: 0px;
    margin: 0px;
  }
  &__item {
    margin: 0px 12px 12px 0px;
    float: left;
    @media only screen and (min-width: 1200px) {
      margin-left: 30px;
    }
  }
  &__thumbnail{
    display: block;
    padding: 4px;
    line-height: 0px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.055);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.055);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.055);
    &--selected{
      background: #2196f3;
      &:before{
        content: '✔️';
        position: absolute;
        color: #2196f3;
        margin-top: 250px;
        margin-left: 208px;
        font-size: 20px;
        border-radius: 3px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
      }
    }
  }
  &__img{
    -webkit-user-drag: none;
    display: block;
    object-fit: cover;
    max-width: 100%;
    margin-right: auto;
    margin-left: auto;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
  }
}
</style>
